import { useBreakpoints } from '@vueuse/core'
import variables from '@/assets/variables.json' // Import your breakpoints from JSON

export const useSwdBreakpoints = () => {
  // Extract breakpoints from JSON
  const { xs, sm, md, lg, xl } = variables

  // Pass the breakpoints to useBreakpoints
  const breakpointsObject = useBreakpoints({
    xs,
    sm,
    md,
    lg,
    xl
  })

  return breakpointsObject
}
